// Samford's undergraduate majors (#2748). Read on 2026-10-01 from the
// official Samford catalog site (catalog.samford.edu), whose current catalog
// is the "2026-2027 Samford Undergrad Catalog (Working Draft)" (catoid=34;
// the 2025-2026 edition is marked archived). The catalog's pages answer plain
// fetches with a browser challenge, so the program list was read through the
// catalog's own public widget API (catalog id 8): every program typed
// "Major" with a bachelor's degree type, placed under the school its catalog
// hierarchy names. Left out: minors, certificates, accelerated
// bachelor-to-graduate pathways, the separate concentration entries
// ("... w/a Concentration in ...", and the four "Interdisciplinary
// Concentration" entries in political science and world languages), and the
// online, degree-completion, second-degree and RN to BSN programs (most sit
// under Continuing Studies). Brock Scholars appears in the catalog twice
// (Fellows and Non-Fellows) and is listed once. Names are the catalog's,
// with the trailing word "Major" and the degree in parentheses moved out;
// degree abbreviations are the catalog's own (BA, BS, BSBA, BSA, BFA, BM,
// BME, BSE, BSN). The KB's majors list was the starting point; the catalog
// wins.
const majors = {
    "slug": "samford-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Samford's 2026-2027 undergraduate catalog, grouped by the school that offers it, with the degree it leads to. Concentrations, minors, online and degree-completion programs and graduate programs are left out.",
    "groups": [
        {
            "name": "Howard College of Arts & Sciences",
            "source": {
                "label": "Samford 2026-2027 Undergraduate Catalog, Howard College of Arts & Sciences",
                "url": "https://catalog.samford.edu/content.php?catoid=34&navoid=2256"
            },
            "majors": [
                {
                    "name": "Biblical Studies",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Christian and Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Classical Civilization",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "Greek",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Journalism and Mass Communication",
                    "degree": "BA"
                },
                {
                    "name": "Latin",
                    "degree": "BA"
                },
                {
                    "name": "Law and History",
                    "degree": "BA"
                },
                {
                    "name": "Law, Philosophy, and the Classical World",
                    "degree": "BA"
                },
                {
                    "name": "Marine Science",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy and Religion",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "World Languages and Cultures: French, German, and/or Spanish (Two Languages)",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Brock School of Business",
            "source": {
                "label": "Samford 2026-2027 Undergraduate Catalog, Brock School of Business",
                "url": "https://catalog.samford.edu/content.php?catoid=34&navoid=2262"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BSBA"
                },
                {
                    "name": "Brock Scholars",
                    "degree": "BSBA",
                    "note": "The catalog lists Brock Scholars as one major in two versions, for Fellows and for non-Fellows."
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BSBA"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BSBA"
                },
                {
                    "name": "Finance",
                    "degree": "BSBA"
                },
                {
                    "name": "Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "School of the Arts",
            "source": {
                "label": "Samford 2026-2027 Undergraduate Catalog, School of the Arts",
                "url": "https://catalog.samford.edu/content.php?catoid=34&navoid=2257"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "BSA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Christian Ministry",
                    "degree": "BA"
                },
                {
                    "name": "Commercial Music",
                    "degree": "BA"
                },
                {
                    "name": "Composition",
                    "degree": "BM"
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "Game Design",
                    "degree": "BS"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "Interior Design",
                    "degree": "BFA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BS"
                },
                {
                    "name": "Music and Worship",
                    "degree": "BM"
                },
                {
                    "name": "Music: Instrumental Music Concentration",
                    "degree": "BME"
                },
                {
                    "name": "Music: Vocal/Choral Music Concentration",
                    "degree": "BME"
                },
                {
                    "name": "Musical Theatre",
                    "degree": "BFA"
                },
                {
                    "name": "Performance: Instrumental Music",
                    "degree": "BM"
                },
                {
                    "name": "Performance: Organ",
                    "degree": "BM"
                },
                {
                    "name": "Performance: Piano",
                    "degree": "BM"
                },
                {
                    "name": "Performance: Piano w/Pedagogy Emphasis",
                    "degree": "BM"
                },
                {
                    "name": "Performance: Voice",
                    "degree": "BM"
                },
                {
                    "name": "Studio Art",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Theatre for Youth: Performance and Teaching Artistry",
                    "degree": "BFA"
                },
                {
                    "name": "Worship Leadership",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Orlean Beeson School of Education",
            "source": {
                "label": "Samford 2026-2027 Undergraduate Catalog, Orlean Beeson School of Education",
                "url": "https://catalog.samford.edu/content.php?catoid=34&navoid=2263"
            },
            "majors": [
                {
                    "name": "Early Childhood/Special Education/Elementary/Collaborative (ESEC)",
                    "degree": "BSE"
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "BA"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BSE"
                }
            ]
        },
        {
            "name": "School of Health Professions",
            "source": {
                "label": "Samford 2026-2027 Undergraduate Catalog, School of Health Professions",
                "url": "https://catalog.samford.edu/content.php?catoid=34&navoid=2266"
            },
            "majors": [
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "BS"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Sport Administration",
                    "degree": "BS"
                },
                {
                    "name": "Sports Medicine",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Moffett & Sanders School of Nursing",
            "source": {
                "label": "Samford 2026-2027 Undergraduate Catalog, Moffett & Sanders School of Nursing",
                "url": "https://catalog.samford.edu/content.php?catoid=34&navoid=2264"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "McWhorter School of Pharmacy",
            "source": {
                "label": "Samford 2026-2027 Undergraduate Catalog, McWhorter School of Pharmacy",
                "url": "https://catalog.samford.edu/content.php?catoid=34&navoid=2265"
            },
            "majors": [
                {
                    "name": "Pharmacy Studies",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Public Health",
            "source": {
                "label": "Samford 2026-2027 Undergraduate Catalog, School of Public Health",
                "url": "https://catalog.samford.edu/content.php?catoid=34&navoid=2267"
            },
            "majors": [
                {
                    "name": "Culinary and Wellness Nutrition Management",
                    "degree": "BS"
                },
                {
                    "name": "Healthcare Administration",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition and Dietetics",
                    "degree": "BS"
                },
                {
                    "name": "Public Health and Preventive Medicine",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
